// extracted by mini-css-extract-plugin
export default {"projectGrid":"projectList_projectGrid__rpeLS"};